import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "border-b h-10 md:h-12 border-gray-200 flex-shrink-0" };
const _hoisted_2 = { class: "flex items-center flex-shrink-0 h-full" };
const _hoisted_3 = {
    key: 0,
    class: "px-2"
};
const _hoisted_4 = { class: "capitalize text-primary text md:text-3xl font-bold truncate w-11/12" };
const _hoisted_5 = { class: "" };
const _hoisted_6 = { class: "hidden md:flex items-center" };
const _hoisted_7 = { class: "mx-3" };
const _hoisted_8 = { class: "flex md:hidden items-center" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-bars text-lg" }, null, -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = {
    key: 0,
    class: "absolute top-0 left-0 h-full w-full bg-white z-10"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-times text-lg" }, null, -1);
const _hoisted_13 = [
    _hoisted_12
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_dropdown = _resolveComponent("user-dropdown");
    const _component_LanguageSelector = _resolveComponent("LanguageSelector");
    const _component_MobileMenu = _resolveComponent("MobileMenu");
    const _component_spinner_modal = _resolveComponent("spinner-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("header", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_ctx.$slots.leftButton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "leftButton")
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["flex-grow truncate", { 'px-2': !_ctx.$slots.leftButton }])
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title")
                    ])
                ], 2),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, [
                            _createVNode(_component_user_dropdown)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_LanguageSelector)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        (!_ctx.showPopUp)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "cursor-pointer px-2",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showPopUp = true))
                            }, _hoisted_10))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        (_ctx.showPopUp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_MobileMenu, {
                    onCloseMenu: _cache[1] || (_cache[1] = ($event) => (_ctx.showPopUp = false)),
                    onDoLogout: _ctx.doLogout,
                    onGoToSelection: _ctx.goToSelection
                }, null, 8, ["onDoLogout", "onGoToSelection"])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showPopUp)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "absolute right-2 top-4 md:right-6 md:top-6 cursor-pointer z-10 xl:hidden px-2",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showPopUp = false))
            }, _hoisted_13))
            : _createCommentVNode("", true),
        (_ctx.statusLoginSpinner)
            ? (_openBlock(), _createBlock(_component_spinner_modal, { key: 2 }, {
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('spinner.logout')), 1)
                ]),
                _: 1
            }))
            : _createCommentVNode("", true)
    ], 64));
}
